import { laptopContents } from "@/data/categories/contents/laptop";
import { komputerContents } from "@/data/categories/contents/komputer";
import { serverContents } from "@/data/categories/contents/server";
import { printerContents } from "@/data/categories/contents/printer";
import { cameraContents } from "@/data/categories/contents/kamera";
import { tvContents } from "@/data/categories/contents/tv";
import { videotronContents } from "@/data/categories/contents/videotron";
import { projectorContents } from "@/data/categories/contents/projector";
import { soundSystemContents } from "@/data/categories/contents/soundSystem";
import { gensetContents } from "@/data/categories/contents/genset";
import { tabletContents } from "@/data/categories/contents/tablet";
import { cctvContents } from "@/data/categories/contents/cctv";
import { lightingContents } from "@/data/categories/contents/lighting";
import { screenContents } from "@/data/categories/contents/screen";

export const contents: Record<string, React.ReactNode> =  {
  laptop: laptopContents,
  komputer: komputerContents,
  server: serverContents,
  printer: printerContents,
  kamera: cameraContents,
  tv: tvContents,
  videotron: videotronContents,
  projector: projectorContents,
  soundSystem: soundSystemContents,
  genset: gensetContents,
  tablet: tabletContents,
  cctv: cctvContents,
  lighting: lightingContents,
  screen: screenContents,
};